/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.PassLastChanceWindow, {
    rewards: {
        text: {
            x: { align: "center", dx: -37 },
            y: { align: "center", dy: 36 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassBuyTicketWindow, {
    rewards: {
        icon: {
            dx: 1,
            dy: 5
        }
    }
});
